import { Box, ButtonBase, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  onClick: () => void;
  actionDisabled?: boolean;
}

const GridTextHoverAction = ({ onClick, actionDisabled, children }: PropsWithChildren<Props>) => {
  if (actionDisabled) {
    return <Typography noWrap>{children}</Typography>;
  }

  return (
    <ButtonBase
      onClick={onClick}
      disableRipple
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        height: "100%",
        minWidth: 0,
        font: "inherit",
        color: "inherit",
        textAlign: "left",
        ":hover": { color: "primary.main" },
      }}
    >
      <Box component="span" sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {children}
      </Box>
    </ButtonBase>
  );
};

export default GridTextHoverAction;
